import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-general-info',
  imports: [MatButton],
  templateUrl: './general-info.component.html',
  styleUrl: './general-info.component.scss',
  standalone: true
})
export class GeneralInfoComponent {
  protected readonly window = window;
}
